export enum ColorMode {
  Light = 'Light',
  Dark = 'Dark'
}
